import { createSlice, createSelector } from "@reduxjs/toolkit";
import { apiCallBegan } from "./api";
import config from "../../config.json";

const slice = createSlice({
  name: "timeLogInvoice",
  initialState: {
    list: [],
    loading: false,
    lastFetch: null,
    subInvDocDeleteStatus: false,
    recInvDocDeleteStatus: false,
    agencyInvDocDeleteStatus: false,
  },
  reducers: {
    timeLogInvocieReceived: (timeLogInvoice, action) => {
      timeLogInvoice.list = action.payload;
      timeLogInvoice.loading = false;
      timeLogInvoice.lastFetch = Date.now();
      timeLogInvoice.subInvDocDeleteStatus = false;
      timeLogInvoice.recInvDocDeleteStatus = false;
      timeLogInvoice.agencyInvDocDeleteStatus = false;
    },
    taskDone: (timeLogInvoice, action) => {
      timeLogInvoice.loading = false;
    },
    ruleAppDataReceived: (timeLogInvoice, action) => {
      timeLogInvoice.ruleAppData = action.payload;
    },
    subTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.subInvDocDeleteStatus = action.payload;
    },
    recTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.recInvDocDeleteStatus = action.payload;
    },
    agencyTimeLogInvDocDeleted: (timeLogInvoice, action) => {
      timeLogInvoice.agencyInvDocDeleteStatus = action.payload;
    },
  },
});

export const {
  timeLogInvocieReceived,
  taskDone,
  ruleAppDataReceived,
  subTimeLogInvDocDeleted,
  recTimeLogInvDocDeleted,
  agencyTimeLogInvDocDeleted,
} = slice.actions;
export default slice.reducer;

export const loadTimeLogInvoice = (id) =>
  apiCallBegan({
    url: config.GetTimeLogInvoice + id,
    onSuccess: timeLogInvocieReceived.type,
  });

export const deleteAgencyTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: agencyTimeLogInvDocDeleted.type,
  });
export const deleteSubcontractorTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: subTimeLogInvDocDeleted.type,
  });

export const deleteRecruiterTimeLogInvDoc = (id) =>
  apiCallBegan({
    url: config.DeleteTimeLogInvoiceDoc + id,
    method: "delete",
    onSuccess: recTimeLogInvDocDeleted.type,
  });

export const getTimeLogInvoice = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.list,
);

export const getSubTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.subInvDocDeleteStatus,
);

export const getRecTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.recInvDocDeleteStatus,
);
export const getAgencyTimeLogInvDocDeleteStatus = createSelector(
  (state) => state.entities.timeLogInvoice,
  (timeLogInvoice) => timeLogInvoice.agencyInvDocDeleteStatus,
);
